module.exports = __webpack_public_path__ + "img/qa.efebdd9d.jpg";